import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type SupplierTripListItem = ResultOf<
  typeof supplierTripListQuery
>["supplierTrips"]["data"][number];
export const supplierTripListQuery = graphql(`
  query SupplierTripList(
    $first: Int!
    $page: Int
    $where: QuerySupplierTripsWhereWhereConditions
    $orderBy: [QuerySupplierTripsOrderByOrderByClause!]
  ) {
    supplierTrips(
      page: $page
      first: $first
      where: $where
      orderBy: $orderBy
    ) {
      data {
        id
        distance_allowed
        hire_units_allowed
        inclusions {
          id
          type
        }
        supplier {
          id
          measurement
          hire_unit_type
        }
        officeA {
          id
        }
        officeB {
          id
        }
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
